const VISIT_STATUS = {
    AlreadyRegistered: 1
  }
export default VISIT_STATUS